// extracted by mini-css-extract-plugin
export default {"lang":"LangSwitcher_lang__lgdI1","lang__info":"LangSwitcher_lang__info__gkNjz","lang__menu":"LangSwitcher_lang__menu__A9xvZ","lang__open":"LangSwitcher_lang__open__yl7S9"};